import React from "react";
import SubmissionFormsTable from "../components/forms/SubmissionFormsTable";

const DriverStatementSubmissionsTable: React.FC = () => (
  <SubmissionFormsTable
    apiSegment="driver-statement-submissions"
    title="טבלת אישור קבלת רכב והצהרת נוהג"
    emptyLabel="אין הגשות להצגה"
    formPageUrl="https://rafael-car-show.co.il/driver-statement"
  />
);

export default DriverStatementSubmissionsTable;
